// hooks/province/context.js
import { createContext, useContext, useReducer } from 'react';
import { provinceReducer, initialState } from './reducer';

const ProvinceContext = createContext();

export const ProvinceProvider = ({ children }) => {
    const [state, dispatch] = useReducer(provinceReducer, initialState);

    return <ProvinceContext.Provider value={[state, dispatch]}>{children}</ProvinceContext.Provider>;
};

export const useProvinceContext = () => {
    const context = useContext(ProvinceContext);
    if (!context) {
        throw new Error('useProvinceContext must be used within a ProvinceProvider');
    }
    return context;
};
